var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.64 14.7166C51.42 16.4166 51.47 19.2566 49.74 21.0066L53.73 46.1666L50.86 48.8466L41.8 29.0766L26.77 44.3566L13 47.0866L43.38 14.8866C45.06 13.1066 47.87 13.0266 49.65 14.7266L49.64 14.7166Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6403 14.7158C51.4203 16.4158 51.4703 19.2558 49.7403 21.0058L53.7303 46.1658L50.8603 48.8458L41.8003 29.0758L26.7703 44.3558L20.0703 45.6858L49.6403 14.7258V14.7158Z",
    fill: "#0098C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8188 8.24629C60.8188 11.3063 58.3388 13.7963 55.2688 13.7963C52.1988 13.7963 49.7188 11.3163 49.7188 8.24629C49.7188 5.17629 52.1988 2.69629 55.2688 2.69629C58.3388 2.69629 60.8188 5.17629 60.8188 8.24629Z",
    fill: "#FFC000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3997 47.6063L53.7997 45.2063L47.8697 16.7063L51.0497 13.3663C53.7097 10.0663 58.1497 3.26627 56.4397 1.44627C55.0997 0.0262655 50.6897 2.23627 47.2297 4.68627L41.5197 10.3963L12.7797 4.19627L10.4097 6.61627L32.5797 19.2463L31.2397 20.6763C26.2797 25.7663 20.9397 31.2263 17.5597 34.6663H5.03969L1.17969 38.0663L18.1797 39.9663L20.3097 56.2863L23.3497 52.9663V40.4463",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.15cd60f4970aa24ad1f0863cb3cc3c96.svg";
export { ForwardRef as ReactComponent };